var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuperAdmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8198 1H6.1802C6.65688 1 7.06729 1.33646 7.16078 1.80388L8 6C8 7.30622 7.16519 8.41746 6 8.82929V12H7C8.10457 12 9 12.8954 9 14V20C9 21.6569 7.20914 23 5 23C2.79086 23 1 21.6569 1 20V14C1 12.8954 1.89543 12 3 12H4V8.82929C2.83481 8.41746 2 7.30622 2 6L2.83922 1.80388C2.93271 1.33646 3.34312 1 3.8198 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.00001C16 -1.00011 11 4.00001 11 7.00001C11 10 13.5 12 14 12V20C14 21 14.6 23 17 23C19.4 23 20 21 20 20V12C21 11.6667 23 10.2 23 7.00001C23 3.80001 18 -1 18 1.99996V7.00001H16V2.00001Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuperAdmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SuperAdmin.8b7b08244f17bac34311a4436fc16344.svg";